<template>
  <div>
   <v-row class="rounded no-gutters back-filtro pa-1" justify="center" align="center">
      <v-col cols="12" class="ma-0 pa-0 d-flex align-center">
        <span class="subtitle-1 font-weight-bold" color="primary">{{title}}</span>
        <v-tooltip top>
          <template v-slot:activator="{ on }">            
            <v-btn text icon color="primary" class="ml-auto" x-small @click="remove" v-on="on">
              <v-icon dark small>fa-trash-alt</v-icon>
            </v-btn>
          </template>
          <span>Eliminar filtro</span>
        </v-tooltip>
      </v-col>   
      <v-col  cols="12">
        <span class="text-primary">Seleccione Opción</span>
        <v-select
          :items="itemsSelect"
          item-text="titulo"
          item-value="valor"
          v-model="selectOpcion"
          hide-details          
          outlined
          dense>
        </v-select>
      </v-col>
      <v-col v-if="selectOpcion!='between'" cols="12" class="py-0 ma-0">
        <span class="text-primary">Valor Fecha Filtrar</span>
        <v-dialog
          ref="dialog"
          v-model="modalCalendar"
          :return-value.sync="FechaSelect"
          persistent
          width="290px">
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="FechaSelect"
              prepend-icon="fa-calendar-alt"
              readonly
              v-on="on"
              outlined
              hide-details
              dense>
            </v-text-field>
          </template>
          <v-date-picker v-model="FechaSelect" scrollable locale="es-419" color="primarydark">
            <v-row class="white">
              <v-col cols="12" class="text-center">
                <v-btn class="mx-2" rounded depressed light outlined color="primary" @click="modalCalendar = false">Cancelar</v-btn>
                <v-btn class="mx-2" rounded depressed light color="primary" @click="$refs.dialog.save(FechaSelect)">OK</v-btn>
               </v-col>
            </v-row>
          </v-date-picker>
        </v-dialog>
      </v-col>
      <v-col v-if="selectOpcion=='between'" md="12" sm="12" class="py-0 ma-0">
        <span class="text-primary">Rango de Fechas a Filtrar</span>
        <v-dialog
          ref="dialog"
          v-model="modalCalendarRange"
          :return-value.sync="FechaRange"
          persistent
          width="auto">
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="dateRangeText"
              prepend-icon="fa-calendar-alt"
              readonly
              v-on="on"
              outlined
              hide-details
              dense>
            </v-text-field>
          </template>
          <v-card  class="pa-1">
            <v-card-text class="pa-0 pt-1">
              <v-row class="no-gutters text-center">
                <v-col cols="12" sm="6" class="pa-1">
                  <h2 class="text-semibold text-primary-dark ma-0 pa-0 text-center text-uppercase">Fecha inicio</h2>
                  <v-date-picker v-model="FechaRange[0]" scrollable locale="es-419" color="primarydark">
                  </v-date-picker>
                </v-col>
                <v-divider vertical v-if="!$vuetify.breakpoint.xs"></v-divider>
                <v-col cols="12" v-else> <v-divider></v-divider> </v-col>
                <v-col cols="12" sm="6" class="pa-1">
                  <h2 class="text-semibold text-primary-dark ma-0 pa-0 text-center text-uppercase">Fecha fin</h2>
                  <v-date-picker v-model="FechaRange[1]" scrollable locale="es-419" color="primarydark">
                  </v-date-picker>
                </v-col>
              </v-row>
              <div style="width:100%" class="text-center under-sec-nomargin">
                <v-btn class="mx-2" depressed rounded outlined color="primary" @click="modalCalendarRange = false">Cancelar</v-btn>
                <v-btn class="mx-2" depressed rounded color="primary" @click="$refs.dialog.save(FechaRange)">Aceptar</v-btn>
              </div>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  import mixinGridComponenteFiltros from "@/mixins/GridComponenteFiltros.js"

  export default {
    name:"DateText",
    mixins: [mixinGridComponenteFiltros],
    data() {
      return {
        itemsSelect: [
          {titulo:'Mayor Igual',valor: '>='},
          {titulo:'Menor Igual',valor: '<='},
          {titulo:'Igual',valor: '='},
          {titulo:'Entre',valor: 'between'},

        ],
        selectOpcion  : '=',
        valorConsulta : '',
        modalCalendar : false,
        modalCalendarRange : false,
        // FechaSelect   : new Date().toISOString().substr(0, 10),
        FechaSelect   : null,
        FechaRange    :[this.FechaSelect, this.FechaSelect],
      }
    },
    mounted() {
      this.stringConsulta ()
    },
    methods: {
      stringConsulta (){
        let sConsulta = ''
        let sValorMostrar = ''

        switch (this.selectOpcion) {
          case '':
            sConsulta = ''
          break
          case '>=':
            sConsulta = ">= '" + this.FechaSelect + "'"
            sValorMostrar = ">= '" + this.FechaSelect + "'"
          break
          case '<=':
            sConsulta = "<= '" + this.FechaSelect + "'"
            sValorMostrar = "<= '" + this.FechaSelect + "'"
          break
          case '=':
             //sConsulta = "= '" + this.FechaSelect + "'"
            sConsulta = ` between '${this.FechaSelect} 00:00:00' AND  '${this.FechaSelect} 23:59:59'`
            sValorMostrar = this.FechaSelect
          break
          case 'between':
            // sConsulta = "between '" + this.FechaRange.join("' AND '") +"'"
            sConsulta = ` between '${this.FechaRange[0]} 00:00:00' AND  '${this.FechaRange[1]} 23:59:59'`
            sValorMostrar = ` Entre ${this.FechaRange[0]} - ${this.FechaRange[1]}`
          break
        }
        this.$emit("input",sConsulta)

        this.onAddInfoFiltro(this.campo , this.title, sValorMostrar)
      }
    },
    computed: {
      dateRangeText () {
        return this.FechaRange.join(' ~ ')
      }
    },
    watch: {
      FechaSelect(nuevo, viejo) {
        nuevo
        viejo
        //console.log ('DateText watch fechaSelect', nuevo, viejo )
        this.stringConsulta();
      },
      FechaRange() {
        this.stringConsulta();
      },
      selectOpcion() {
        this.stringConsulta();
      },

    },  
  }
</script>

<style lang="scss" scoped>
</style>